module.exports = __webpack_public_path__ + "img/circuit-veteran-3.a9f6c3c1.png";